import { render, staticRenderFns } from "./OrderCalcPosted.vue?vue&type=template&id=dd4ea5b0&scoped=true&"
import script from "./OrderCalcPosted.vue?vue&type=script&lang=ts&"
export * from "./OrderCalcPosted.vue?vue&type=script&lang=ts&"
import style0 from "./OrderCalcPosted.vue?vue&type=style&index=0&id=dd4ea5b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd4ea5b0",
  null
  
)

export default component.exports